export const researchData = [
    {
      id: 1,
      title: "Ciência de Dados e Inteligência Artificial",
      description: [
        "Aplicação de técnicas avançadas de análise de dados e algoritmos de aprendizado de máquina;",
        "Investigação e desenvolvimento de modelos preditivos e sistemas inteligentes;",
        "Pesquisa das implicações éticas e sociais da adoção de Inteligência Artificial."
      ],
      image: "./projects-images/image 1.png",
      titleColor: "yellow"
    },
    {
      id: 2,
      title: "Transformação Digital e Gestão de Projetos",
      description: [
        "Concentra-se na concepção, investigação e desenvolvimento de soluções tecnológicas e inovadoras;",
        "Aplicação e pesquisa de metodologias ágeis e técnicas de desenvolvimento de software;",
        "Estudo e aplicações de tecnologias emergentes para otimização e inovação de processos de negócio."
      ],
      image: "./projects-images/image 2.png",
      titleColor: "red"
    },
    {
      id: 3,
      title: "Empreendedorismo e Educação Financeira",
      description: [
        "Pesquisas sobre as habilidades e competências empreendedoras e financeiras em diversos públicos;",
        "Investigações relacionadas ao desenvolvimento de ecossistemas de inovação;",
        "Criação de programas educacionais, ferramentas de suporte à gestão financeira e análise de políticas púbicas."
      ],
      image: "./projects-images/image 6.png",
      titleColor: "yellow"
    },
    {
      id: 4,
      title: "Negócios e Internet das Coisas",
      description: [
        "Investigação e aplicação de estratégias e soluções que aproveitam o potencial da interconectividade entre dispositivos de Internet das Coisas (IoT);",
        "Explorar as fronteiras da IoT e dos negócios, contribuindo para o desenvolvimento de soluções inteligentes e conectados que auxiliem negócios."
      ],
      image: "./projects-images/image 4.png",
      titleColor: "red"
    },
    {
      id: 5,
      title: "Gestão do Conhecimento e Estratégias de Inovação",
      description: [
        "Explorar como as organizações podem capturar, compartilhar e aplicar o conhecimento de forma eficaz para promover a inovação contínua, incluindo  o uso de plataformas colaborativas, comunidades de prática e sistemas de gestão do conhecimento."
      ],
      image: "./projects-images/image 5.png",
      titleColor: "yellow"
    }
  ];